export const getRelease = (
  sentry?: string,
  serverEnv?: string,
  buildVersion?: string
) => {
  let release: string | undefined;
  let environment: string | undefined;
  if (sentry) {
    if (serverEnv && buildVersion) {
      switch (serverEnv) {
        case 'prod':
        case 'production':
          environment = 'production';
          break;
        case 'stage':
        case 'staging':
          environment = 'staging';
          break;
        default:
          environment = 'development';
          break;
      }
      release = `frontend-${serverEnv}-${buildVersion}`;
    }
  }
  return { release, environment };
};
